import BitesApi from '..';

export const query = (queryParams: string) => BitesApi.get(`/playlists/${queryParams}`);
export const queryFeed = (organizationId: string, queryParams: string) =>
  BitesApi.get(`/content/organization/${organizationId}/feed/playlist/${queryParams}`);
export const queryPublicFeed = (queryParams: string) => BitesApi.get(`/public/playlists/${queryParams}`);

export const getById = (playlistId: number, headers?: { [key: string]: number | string | boolean }) =>
  BitesApi.get(`/playlists/${playlistId}/`, { headers });
